module.exports = __webpack_public_path__ + "e1ffe9ecc7de31eb5b0ac2fddc7b9106.svg";